// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import Logo from "./assets/league-logo.png";
var TEMPLATE_MODULE_ASSETS_MAP = {
  LOGO: Logo
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(TEMPLATE_MODULE_ASSETS_MAP);
};

// src/constants/feature-flags.ts
var CARE_TEAM = "care_team";

// src/index.ts
initModule();
export {
  CARE_TEAM
};
//# sourceMappingURL=index.js.map